import { render, staticRenderFns } from "./CommandTile.vue?vue&type=template&id=099bc6c4"
import script from "./CommandTile.vue?vue&type=script&lang=ts"
export * from "./CommandTile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports